import { generateVoiceRecordingName } from '@faceup/utils'
import type { RecordType } from './types'

export const buildRecordingFile = (recording: RecordType): File =>
  new File([recording.data], generateVoiceRecordingName(), { type: 'audio/mpeg' })
